module.exports = __webpack_public_path__ + "static/media/attribute_card_cost.58a7e7a0.png";